exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-26e5f136] .el-card__body{height:100%}.bg_custom[data-v-26e5f136]{background:rgba(237,240,249,.5)}.img_dialog[data-v-26e5f136]  .el-dialog__body{padding-top:0}.required-text--color[data-v-26e5f136]{color:#ff3a30}.down-file--color[data-v-26e5f136]{color:#acdbff}", ""]);

// exports
